import { I18nComponente } from "@/types/gerais"

export const OModalExcluirAtividadei18n: I18nComponente = {
  "pt-BR": {
    voltar: "voltar",
    simDeletar: "sim, deletar",
    deletarAtividade: "deletar atividade?",
    temCertezaQueDeseja: "Tem certeza que deseja",
    seguinteAtividade: "a seguinte atividade?",
    por: "por",
    iniciadaEm: "iniciada em",
    encerradaEm: "encerrada em",
    aoDesconsiderarAtividade: "Ao desconsiderar a atividade",
    elaNaoSeraMaisVisivelNoCalendario: "ela não será mais visível no calendário",
    suasHorasNaoContaraoParaTotalDeHorasDoProfissional: "suas horas não contarão para o total de horas do profissional",
    aoDeletarAtividadeElaSeraPermanentementeExcluida: "Ao deletar a atividade, ela será permanentemente excluída e suas horas não contarão para o total de horas do profissional",
    atividadeDeletada: "atividade deletada",
    atividadeNaoDeletada: "atividade não deletada",
    desconsiderarAtividade: "desconsiderar atividade?",
    simDesconsiderar: "sim, desconsiderar",
    atividadeDesconsiderada: "atividade desconsiderada",
    atividadeNaoDesconsiderada: "atividade não desconsiderada",
  },
  "es-CO": {
    voltar: "volver",
    simDeletar: "sí, borrar",
    deletarAtividade: "borrar actividad?",
    temCertezaQueDeseja: "¿Estás seguro de que deseas",
    seguinteAtividade: "la siguiente actividad?",
    por: "por",
    iniciadaEm: "iniciada en",
    encerradaEm: "finalizada en",
    aoDesconsiderarAtividade: "Al no considerar la actividad",
    elaNaoSeraMaisVisivelNoCalendario: "ya no será visible en el calendario",
    suasHorasNaoContaraoParaTotalDeHorasDoProfissional: "sus horas no contarán para el total de horas del profesional",
    aoDeletarAtividadeElaSeraPermanentementeExcluida: "Al eliminar la actividad, se eliminará permanentemente y sus horas no contarán para el total de horas del profesional",
    atividadeDeletada: "actividad eliminada",
    atividadeNaoDeletada: "actividad no eliminada",
    desconsiderarAtividade: "no considerar actividad?",
    simDesconsiderar: "sí, no considerar",
    atividadeDesconsiderada: "actividad no considerada",
    atividadeNaoDesconsiderada: "actividad no no considerada",
  }
}
